import { getFirebaseIdToken } from './getFirebaseIdToken';

export class AuthenticatedApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'AuthenticatedApiError';
  }
}

export async function postAuthenticatedApi<T>(path: string, body: unknown): Promise<T> {
  const idToken = await getFirebaseIdToken();

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(body),
  });

  const payload = await response.json();

  if (!response.ok) {
    throw new AuthenticatedApiError(payload.message || 'Request failed');
  }

  return payload as T;
}
